import { render, staticRenderFns } from "./CrosssellerItem.vue?vue&type=template&id=0457aa08&"
import script from "./CrosssellerItem.vue?vue&type=script&lang=js&"
export * from "./CrosssellerItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kevindenckert/PhpstormProjects/DIA-kleinmore/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0457aa08')) {
      api.createRecord('0457aa08', component.options)
    } else {
      api.reload('0457aa08', component.options)
    }
    module.hot.accept("./CrosssellerItem.vue?vue&type=template&id=0457aa08&", function () {
      api.rerender('0457aa08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/CrosssellerItem.vue"
export default component.exports